import React, { Component } from 'react';
import HTML5Backend from 'react-dnd-html5-backend';
import  TouchBackend  from 'react-dnd-touch-backend'
import PropTypes from 'prop-types';
import { DragDropContext } from 'react-dnd';
import './App.css';

import GalleryContainer from './components/gallery-container/GalleryContainer';
import EditorWrapper from './components/editor-wrapper/EditorWrapper';
import LayoutContainer from './components/layout-container/LayoutContainer';
import PagePreviewContainer from './components/page-preview-container/PagePreviewContainer';
import TopBarContainer from './components/top-bar/top-bar-container/TopBarContainer';
import TextTools from './components/text-tools/TextTools';
import {
  hideComponent,
  browserNotSupported } from './redux/helpers';
import SavebookLoader from './components/savebook-loader/savebookLoader';

function isTouchDevice() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}

function setDndBackend() {
  return isTouchDevice() ? TouchBackend : HTML5Backend;
}

class App extends Component {
  constructor(args) {
    super(...args);
    this.state = {
      hideComponent: false,
    };
    console.log('csokika', isTouchDevice())
  }

  componentWillMount() {
    if (hideComponent()) {
      this.setState({
        hideComponent: true,
      });
    }
  }


  render() {
    const { lang } = this.props;

    if (browserNotSupported()) {
      return (
        <div className="unsopported">
          <p>{lang.browserNotSupported}</p>
        </div>
      );
    }

    return (
      <div className="BookDesigner">
        <div className="Topbar">
          <TopBarContainer lang={lang} />
        </div>
        <div className="BookDesigner_ContentColumn">
          <div className="BookDesignerTopBar">
            <PagePreviewContainer lang={lang} />
          </div>

          <div className="BookDesigner_MiddleWrapper">
            <div className={`BookDesigner_LeftColumn ${this.state.hideComponent ? 'hide' : ''} `}>
              <GalleryContainer />
            </div>
            <div className={`BookDesigner_MiddleColumn ${this.state.hideComponent ? 'hide' : ''}`}>
              <EditorWrapper lang={lang} />
              <div className="textTools">
                <TextTools
                  lang={lang}
                />
              </div>
              <div className="BookDesigner_BottomBar">
                <LayoutContainer lang={lang} />
              </div>
            </div>
          </div>
        </div>
        <div className="BookDesigner_RightColumn" />
        <SavebookLoader lang={lang} />
      </div>
    );
  }
}

App.defaultProps = {
  lang: {},
};

App.propTypes = {
  lang: PropTypes.object,
};

export default DragDropContext(setDndBackend())(App);



// WEBPACK FOOTER //
// ./src/App.jsx